module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', {
    staticClass: "tocol"
  }, [_c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/0_chapter1wishingformonth"
    }
  }, [_vm._v("CHAPTER 1 - WISHING FOR MONTH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/1_chapter2oldleatherbook"
    }
  }, [_vm._v("CHAPTER 2 - OLD LEATHER BOOK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/2_chapter3coldeyedworldlyemotion"
    }
  }, [_vm._v("CHAPTER 3 - COLD-EYED WORLDLY EMOTION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/3_chapter4heartofmartialarts"
    }
  }, [_vm._v("CHAPTER 4 - HEART OF MARTIAL ARTS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/4_chapter5notthesame"
    }
  }, [_vm._v("CHAPTER 5 - NOT THE SAME")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/5_chapter6oneyeardone"
    }
  }, [_vm._v("CHAPTER 6 - ONE YEAR DONE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/6_chapter7idowhatido"
    }
  }, [_vm._v("CHAPTER 7 - I DO WHAT I DO")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/7_chapter8finallyhishearthadbeenmoved"
    }
  }, [_vm._v("CHAPTER 8 - FINALLY HIS HEART HAD BEEN MOVED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/8_chapter9plumandbamboohorse"
    }
  }, [_vm._v("CHAPTER 9 - PLUM AND BAMBOO HORSE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/9_chapter10bodyskin"
    }
  }, [_vm._v("CHAPTER 10 - BODY SKIN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter11opportunityapproaches",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11 - OPPORTUNITY APPROACHES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter12schoolmateyouth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12 - SCHOOLMATE YOUTH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter13specialabilityawakening",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13 - SPECIAL ABILITY AWAKENING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter14bendthewaistformoney",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14 - BEND THE WAIST FOR MONEY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter15misuse",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15 - MISUSE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter16seniorapprenticebrothergoesout",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16 - SENIOR-APPRENTICE BROTHER GOES OUT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter17calligraphy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17 - CALLIGRAPHY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter18pushonthedoor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18 - PUSH ON THE DOOR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter19achievinggoals",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19 - ACHIEVING GOALS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter20thingsaregoingaway",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20 - THINGS ARE GOING AWAY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter21goabroad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21 - GO ABROAD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter22priceofdeparture",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22 - PRICE OF DEPARTURE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter23beautyleading",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23 - BEAUTY LEADING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter24warmthofjourney",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24 - WARMTH OF JOURNEY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter25cinnabar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25 - CINNABAR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/25_chapter26staticmotility",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26 - STATIC MOTILITY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/26_chapter27gasfeelingout",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27 - GAS FEELING OUT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter28threeyearswork",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28 - THREE YEARS WORK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/28_chapter29wishfulthinking",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29 - WISHFUL THINKING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/29_chapter30economicfissure",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30 - ECONOMIC FISSURE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter31misunderstanding",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31 - MISUNDERSTANDING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/31_chapter32trueheartofthestrong",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32 - TRUE HEART OF THE STRONG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter33fourthbrotheremerged",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33 - FOURTH BROTHER EMERGED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/33_chapter34nanyangdescendinghead",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 34 - NANYANG DESCENDING HEAD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter35humansarelikeants",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 35 - HUMANS ARE LIKE ANTS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/35_chapter36donotprovokeants",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 36 - DO NOT PROVOKE ANTS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/36_chapter37amalgamationoftwophases",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 37 - AMALGAMATION OF TWO PHASES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/37_chapter38cardiacmoment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 38 - CARDIAC MOMENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/38_chapter39yinandyang",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 39 - YIN AND YANG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter40synonym",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 40 - SYNONYM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/40_chapter41taohaipathless",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 41 - TAOHAI PATHLESS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter42taohaipathless2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 42 - TAOHAI PATHLESS(2)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter43ephemeralhappiness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 43 - EPHEMERAL HAPPINESS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/43_chapter44moneymoneymoneymoney",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 44 - MONEY MONEY MONEY MONEY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter45doorrequest",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 45 - DOOR REQUEST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter46500000yuan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 46 - 500000 YUAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter47leesevil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 47 - LEE'S EVIL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/47_chapter48letherbetheone",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 48 - LET HER BE THE ONE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter49youreback",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 49 - YOU'RE BACK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter50hersorrow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 50 - HER SORROW")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter51nailconization",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 51 - NAIL CONIZATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter52onenight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 52 - ONE NIGHT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter53morninglanguage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 53 - MORNING LANGUAGE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter54severalpleasures",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 54 - SEVERAL PLEASURES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/54_chapter55curiosityhuntingpsychology",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 55 - CURIOSITY HUNTING PSYCHOLOGY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter56unrecognizedmeeting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 56 - UNRECOGNIZED MEETING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/56_chapter57youngliexperience",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 57 - YOUNG LI EXPERIENCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/57_chapter58newarrivalinthailand",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 58 - NEW ARRIVAL IN THAILAND")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/58_chapter59thereisnoaftereffect",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 59 - THERE IS NO AFTEREFFECT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/59_chapter60unspeakable",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 60 - UNSPEAKABLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/60_chapter61anacarbazone",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 61 - ANACARBAZONE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/61_chapter62thegoldenchickenstory",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 62 - THE GOLDEN CHICKEN STORY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/62_chapter63iveseenaghost",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 63 - I'VE SEEN A GHOST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/63_chapter64gramsrelic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 64 - GRAM'S RELIC")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/64_chapter65plumblossomdestiny",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 65 - PLUM BLOSSOM DESTINY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/65_chapter66divinepowerofthevalleypath",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 66 - DIVINE POWER OF THE VALLEY PATH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/66_chapter67whowasheinhispreviouslife",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 67 - WHO WAS HE IN HIS PREVIOUS LIFE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/67_chapter68soulsummoningandphantomsummoning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 68 - SOUL-SUMMONING AND PHANTOM SUMMONING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/68_chapter69thekillingart",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 69 - THE KILLING ART")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/69_chapter70thedevilswillofman",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 70 - THE DEVIL'S WILL OF MAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/70_chapter71forcedadmissions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 71 - FORCED ADMISSIONS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/71_chapter72prophesyingevil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 72 - PROPHESYING EVIL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/72_chapter73bloodcorpsesisteryuan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 73 - BLOOD CORPSE SISTER YUAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/73_chapter74crystalpalace",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 74 - CRYSTAL PALACE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/74_chapter75loathsomerice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 75 - LOATHSOME RICE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/75_chapter76suddenattack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 76 - SUDDEN ATTACK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/76_chapter77beattodeath",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 77 - BEAT TO DEATH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/77_chapter78resurrectingfromdeath",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 78 - RESURRECTING FROM DEATH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/78_chapter79yearningforpower",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 79 - YEARNING FOR POWER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/79_chapter80seventhsaint",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 80 - SEVENTH SAINT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/80_chapter81heterophobia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 81 - HETEROPHOBIA")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/81_chapter82bothwereclearlyidentified",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 82 - BOTH WERE CLEARLY IDENTIFIED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/82_chapter83sayyouredead",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 83 - SAY YOU'RE DEAD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/83_chapter84decapitationoil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 84 - DECAPITATION OIL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/84_chapter85beforereturn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 85 - BEFORE RETURN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/85_chapter86unknownshadow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 86 - UNKNOWN SHADOW")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/86_chapter87accidentalkilling",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 87 - ACCIDENTAL KILLING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/87_chapter88recognitionrelationship",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 88 - RECOGNITION RELATIONSHIP")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/88_chapter89periodofoneyear",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 89 - PERIOD OF ONE YEAR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/89_chapter90bewrungdry",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 90 - BE WRUNG DRY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/90_chapter91gotonanyang",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 91 - GO TO NANYANG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/91_chapter92guofamily",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 92 - GUO FAMILY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/92_chapter93missguo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 93 - MISS GUO")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/93_chapter94guofamily",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 94 - GUO FAMILY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/94_chapter95spendthrift",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 95 - SPENDTHRIFT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/95_chapter96liusyutang",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 96 - LIU'S YUTANG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/96_chapter97crazykungfu",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 97 - CRAZY KUNG FU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/97_chapter98hermasterwaseldersisterru",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 98 - HER MASTER WAS ELDER SISTER RU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/98_chapter99martialartsbarrier",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 99 - MARTIAL ARTS BARRIER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/99_chapter100exchangeboxing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 100 - EXCHANGE BOXING")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0